export const normalizeDecimalInput = (value: string) => {
  let v = value.replaceAll(",", ".");
  v = v.replaceAll(/[^0-9.]/g, "");

  const firstDotIndex = v.indexOf(".");
  if (firstDotIndex !== -1) {
    const before = v.slice(0, firstDotIndex + 1);
    const after = v.slice(firstDotIndex + 1).replaceAll(".", "");
    v = before + after;
  }

  return v;
};
